import * as React from 'react';

function BellIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24.247}
      height={28.896}
      viewBox="0 0 24.247 28.896"
      {...props}
    >
      <g data-name={3602145}>
        <g data-name="Group 1107">
          <path
            data-name="Path 659"
            d="M13.867 5.359a.581.581 0 01-.581-.581V2.825a1.163 1.163 0 00-2.325 0v1.952a.581.581 0 01-1.162 0V2.825a2.325 2.325 0 014.649 0v1.952a.581.581 0 01-.581.582z"
            fill="#fff"
            stroke="#fff"
          />
        </g>
        <g data-name="Group 1108">
          <path
            data-name="Path 660"
            d="M12.123 28.396a4.073 4.073 0 01-4.068-4.068.581.581 0 011.162 0 2.906 2.906 0 005.812 0 .581.581 0 011.162 0 4.073 4.073 0 01-4.068 4.068z"
            fill="#fff"
            stroke="#fff"
          />
        </g>
        <g data-name="Group 1109">
          <path
            data-name="Path 661"
            d="M22 24.909H2.244a1.744 1.744 0 01-1.134-3.068 8.081 8.081 0 002.877-6.186v-3.532a8.136 8.136 0 0116.273 0v3.531a8.072 8.072 0 002.868 6.178A1.744 1.744 0 0122 24.909zm-9.88-19.76a6.981 6.981 0 00-6.974 6.974v3.531a9.234 9.234 0 01-3.276 7.067.581.581 0 00.373 1.026H22a.581.581 0 00.378-1.023 9.241 9.241 0 01-3.278-7.069v-3.532a6.981 6.981 0 00-6.974-6.974z"
            fill="#fff"
            stroke="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default BellIcon;
